<template>
    <form-field
        :label="!isBoolean ? label : ''"
        :help-text="helpText"
        inner-container-class="has-icons-right"
    >
        <input-text
            v-if="!isBoolean"
            placeholder="-"
            v-model="settingValue"
            :error="error.value"
        />
        <input-checkbox
            v-else
            :label="label"
            v-model="settingValue"
            :error="error.value"
        />
        <span v-if="success" class="icon is-right has-text-success">
            <i class="fas fa-check"></i>
        </span>
        <span v-if="hasIcon && !success" class="icon is-right">{{ setting.unit }}</span>
    </form-field>
</template>

<script>
import { FormField, InputText, InputCheckbox } from '@elems/form'
import debounce from 'lodash/debounce'

export default {
    components: {
        FormField,
        InputText,
        InputCheckbox,
    },

    props: {
        label: String,
        helpText: String,
        skey: String,
        hasIcon: {
            type: Boolean,
            default: true,
        },
        isBoolean: {
            type: Boolean,
            default: false,
        },
        imageWidth: {
            type: Number,
            default: 300,
        },
    },

    computed: {
        setting() {
            return this.$store.getters.settingByKey(this.skey) || {}
        },
        settingValue: {
            get() {
                return this.setting.value || null
            },
            set(value) {
                this.debounceUpdate(value)
            }
        }
    },
    data() {
        return {
            debounceUpdate: debounce(this.update, 600),
            success: false,
            error: [],
        }
    },
    methods: {
        update(value) {
            if (this.setting.id > 0) {
                window.axios.put('/api/settings/settings/' + this.setting.id, { value })
                    .then(({data}) => {
                        this.$store.dispatch('updateSetting', data)
                        this.toggleSuccess()
                        this.error = []
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 422) {
                            this.error = error.response.data.errors
                        }
                    })
            }
        },
        toggleSuccess() {
            this.success = true
            setTimeout(() => {
                this.success = false
            }, 1500)
        }
    }

}
</script>

<style lang="scss" scoped>
.icon {
    margin: 0 10px;
}

.image-container {
    text-align: center;
}
</style>
